import { createBasicSelector } from 'util/redux'
import {
  selectPrefersKbBillingVersion,
  selectPrefersInboxBillingVersion,
} from 'selectors/app/selectAccountPreferences'
import { INBOX, KB } from '../productTypes'

export const selectPreferredBillingVersionByProduct = createBasicSelector(
  selectPrefersKbBillingVersion,
  selectPrefersInboxBillingVersion,
  (accountKbBillingVersion, accountInboxBillingVersion) => {
    return {
      [INBOX]: accountInboxBillingVersion,
      [KB]: accountKbBillingVersion,
    }
  }
)
